module.exports = __webpack_public_path__ + "img/ar-group-logo.5281a571.jpg";